import { forwardRef, type LabelHTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

export const Label = forwardRef<HTMLLabelElement, LabelHTMLAttributes<HTMLLabelElement>>(
  ({ className, ...rest }, ref) => {
    return (
      <label
        ref={ref}
        className={cn(
          'mb-1.5 inline-block text-xs font-medium text-fg-muted',
          className,
        )}
        {...rest}
      />
    )
  },
)

Label.displayName = 'Label'
